export const PAGINATION_STYLE = `
.pagination-box {
    margin-top: 15px;
    display: block;
}
.pagination-range {
    margin-top: 7px;
    margin-left: 3px;
    display: inline-block;
}
.pagination-controllers {
    width: 100%;
}
.pagination-controllers input {
    min-width: 60px;
    /*padding: 1px 0px 0px 5px;*/
    text-align: right;
    margin-bottom: 0;
}

.pagination-limit {
    margin-right: 25px;
    display: inline-table;
    width: 70px;
    float: left;
}
.pagination-pages {
    display: inline-block;
    margin-top: 10px;
}
.pagination-page {
    width: 208px;
    display: contents;
}
.pagination-box button {
    outline: none !important;
}
.pagination-prevpage,
.pagination-nextpage,
.pagination-firstpage,
.pagination-lastpage {
    vertical-align: top;
}
.pagination-reload {
    color: gray;
    font-size: 12px;
}

button {
    background-color:#00334e !important;
}

.btn-floating:hover {
    background-color:rgb(0,102,156) !important;
}

input[type=number]:not(.browser-default):focus:not([readonly]) {
    border-bottom: 1px solid #00334e;
    box-shadow: none;
}

.btn:disabled {
    background-color: #eef7fc!important;
}

`;


// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/node_modules/angular-4-data-table/src/components/pagination.style.ts